import { render, staticRenderFns } from "./kedua.vue?vue&type=template&id=2ba53f52&scoped=true&"
import script from "./kedua.vue?vue&type=script&lang=js&"
export * from "./kedua.vue?vue&type=script&lang=js&"
import style0 from "./kedua.vue?vue&type=style&index=0&id=2ba53f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba53f52",
  null
  
)

export default component.exports